const te = {
  common: {
    home: "హోమ్",
    materials: "మెటీరియల్స్",
    rateCard: "రేట్ కార్డ్",
    cart: "కార్ట్",
    myBookings: "నా బుకింగ్స్",
    login: "లాగిన్",
    signup: "సైన్ అప్",
    dashboard: "డాష్‌బోర్డ్",
    settings: "సెట్టింగ్స్",
    logout: "లాగౌట్",
    save: "సేవ్ చేయండి",
    loading: "లోడ్ అవుతోంది...",
  },
  header: {
    brand: "మిస్త్రీబజార్",
  },
  settings: {
    title: "సెట్టింగ్స్",
    subtitle: "మీ ప్రొఫైల్, భాష, చిరునామా, అకౌంట్ సెట్టింగ్స్‌ను నిర్వహించండి.",
    profileSection: "ప్రొఫైల్",
    languageSection: "భాష",
    addressSection: "సేవ్ చేసిన చిరునామా",
    accountSection: "అకౌంట్",
    fullName: "పూర్తి పేరు",
    phone: "ఫోన్ నంబర్",
    email: "ఈమెయిల్",
    city: "నగరం",
    preferredLanguage: "ఇష్టమైన భాష",
    flatHouseNo: "ఫ్లాట్ నం / ఇల్లు నం",
    streetArea: "వీధి / ప్రాంతం",
    state: "రాష్ట్రం",
    country: "దేశం",
    pincode: "పిన్ కోడ్",
    role: "పాత్ర",
    uniqueId: "యూనిక్ ఐడి",
    saveProfile: "ప్రొఫైల్ సేవ్ చేయండి",
    saveAddress: "చిరునామా సేవ్ చేయండి",
    accountDetails: "అకౌంట్ వివరాలు",
  },
  home: {
    heroTitle: "మిస్త్రీబజార్",
    heroText:
      "సర్వీసులు బుక్ చేసుకోండి, మెటీరియల్స్ కొనండి, మీ ఇంటిని నిర్మించండి, మరియు స్థానిక సమన్వయం, దాచిన ఖర్చులు, అనిశ్చిత టైమ్‌లైన్ వల్ల వచ్చే సమస్యలను తగ్గించండి.",
    buyMaterials: "మెటీరియల్స్ కొనండి",
    buildYourHouse: "మీ ఇల్లు నిర్మించండి",
    exploreMembership: "మెంబర్‌షిప్ చూడండి",
    services: "సర్వీసులు",
    about: "మా గురించి",
    contactUs: "మమ్మల్ని సంప్రదించండి",
    privacyPolicy: "ప్రైవసీ పాలసీ",
    terms: "నిబంధనలు & షరతులు",
  },
};

export default te;